import { getPackageScheduleDeliveryWindow, readFilterState, saveFilterState } from "../../util/CommonUtils";
import { DWELL_FILTER_STATE_KEY, DWELL_FILTER_ACTIONS, PACKAGE_TYPE_GROCERY, PACKAGE_TYPE_CORE } from "../constants/CommonConstants";


const getFilterDataFromPackageList = (packageDataList) => {
    let packageTypeSet = new Set();
    let packageDeliveryWindowSet = new Set();
    if (packageDataList) {
        packageDataList.map((packageDetail) => {
            if (packageDetail.isGrocery) {
                packageTypeSet.add(PACKAGE_TYPE_GROCERY)
            }
            else {
                packageTypeSet.add(PACKAGE_TYPE_CORE)
            }
            let delWindow = getPackageScheduleDeliveryWindow(packageDetail);
            if (delWindow) {
                packageDeliveryWindowSet.add(delWindow);
            }
            return packageDetail;
        })
    }
    
    return {
        packageType: [...packageTypeSet], 
        packageScheduledDeliveryWindow: [...packageDeliveryWindowSet]
    }
}

export const DwellFilterReducer = (state, action) => {
    switch (action.type) {
        case DWELL_FILTER_ACTIONS.RECEIVE_FILTER_DATA: {
            const packageData = getFilterDataFromPackageList(action.data.packageResultList)
            const newState = {...state, data: {...packageData}}
            saveFilterState(DWELL_FILTER_STATE_KEY, newState);
            return newState
        }
        case DWELL_FILTER_ACTIONS.SELECT_PACKAGE_TYPE: {
            const newState = {...state, packageType: action.packageType}
            saveFilterState(DWELL_FILTER_STATE_KEY, newState);
            return newState;
        }
        case DWELL_FILTER_ACTIONS.SELECT_PACKAGE_SCHEDULED_DELIVERY_WINDOW: {
            const newState = {...state, packageScheduledDeliveryWindow: action.packageScheduledDeliveryWindow}
            saveFilterState(DWELL_FILTER_STATE_KEY, newState);
            return newState;
        }
        case DWELL_FILTER_ACTIONS.SELECT_PACKAGE_STATUS_TILE: {
            const newState = {...state, selectedPackageStatusListTile: action.selectedPackageStatusListTile}
            saveFilterState(DWELL_FILTER_STATE_KEY, newState);
            return newState;
        }
        case DWELL_FILTER_ACTIONS.SELECT_TILE: {
            const newState = {...state, selectedTile: action.selectedTile}
            saveFilterState(DWELL_FILTER_STATE_KEY, newState);
            return newState;
        }
        case DWELL_FILTER_ACTIONS.SELECT_EXCEPTION_DWELLING: {
            const newState = {...state, exceptionDwelling: action.exceptionDwelling}
            saveFilterState(DWELL_FILTER_STATE_KEY, newState);
            return newState
        }
        case DWELL_FILTER_ACTIONS.UNLOAD_VIEW:
            return state
        case DWELL_FILTER_ACTIONS.REMOVE_ALL_FILTER: {
            const newState = {...state};
            Object.entries(state).forEach(entry => {
                const key = entry[0];
                const values = entry[1];
                if (Array.isArray(values) && values.length && key !== 'data') {
                    newState[key] = [];
                }
            });
            saveFilterState(DWELL_FILTER_STATE_KEY, newState);
            return newState;
        }
        case DWELL_FILTER_ACTIONS.REMOVE_FILTER: {
            const {key, value} = action.data
            state[key] = state[key].filter(item => item !== value)
            const newItem = state[key].filter(item => item !== value)
            const newState = {...state, [key]: newItem}
            saveFilterState(DWELL_FILTER_STATE_KEY, newState);
            return newState
        }
        case DWELL_FILTER_ACTIONS.LOAD_FILTERS: {
            const savedState = readFilterState(DWELL_FILTER_STATE_KEY);
            if (savedState) {
                return {
                    ...state,
                    ...savedState
                }
            }
            return state;
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/commons/reducer/DwellFilterReducer.js